import { makeStyles } from '@material-ui/styles';
import { Variant } from './interface';
import { ITheme } from '../../../style/theme';
import { colors } from '../../../style/colors';

interface StyleProps {
  variant: Variant;
}

export const useStyles = makeStyles<ITheme, StyleProps>((theme: ITheme) => ({
  root: {
    display: 'flex',
  },
  subHeaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  subHeader: {
    color: colors.darkGray,
  },
  avatar: (props) => ({
    backgroundColor:
      props.variant === 'pink' ? '#E1DEF0' : colors.mainLightBlue,
    color: props.variant === 'pink' ? '#ADA3DA' : colors.white,
    minHeight: 48,
    minWidth: 48,
    maxHeight: 48,
    maxWidth: 48,
    borderRadius: 24,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 16,
    fontWeight: 'bold',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'flex',
    lineClamp: 1,
    WebkitLineClamp: 1,
  }),
}));
